export const pluralize = (count: number, one: string, many: string) => {
  return count === 1 ? one : many;
};

export const pluralizeBooking = (count: number): string =>
  pluralize(count, "booking", "bookings");
